<template>
    <div class="float-left mr-1">
        <span 
            class="text-primary float-left mr-1"
            v-if="mostrarBotao"
        >
            <i 
                class="fa fa-list fa-lg icon-button"
                title="Detalhar consumo por itens"
                @click.stop="ObterConsumoPorItem()"
                ></i>
            </span>
        <b-modal
            hide-footer
            v-model="mostrarModal"
            size="xl"
            @close="limparVariaveis()"
        >
            <b-row>
                <b-col>
                    <app-box titulo="Total da fase">{{
                        fase.valor | currency
                    }}</app-box>
                </b-col>
                <b-col>
                    <app-box titulo="Total consumido">{{
                        totalConsumo | currency
                    }}</app-box>
                </b-col>
                <b-col>
                    <app-box titulo="Saldo previsto">{{
                        fase.saldo | currency
                    }}</app-box>
                </b-col>
                <b-col>
                    <app-box titulo="Saldo real">{{
                        fase.saldoReal | currency
                    }}</app-box>
                </b-col>
            </b-row>
            <div slot="modal-title">
                Consumo Por Itens
            </div>
            <div>
                <app-tabela
                    idTabela="tblConsumoItem"
                    :itens="consumos"
                    :campos="campos"
                    :bordered="false"
                    :small="false"
                    :itensPorPagina="itensPorPagina"
                >
                    <template slot="valorConsumido" slot-scope="data">
                        <p class="text-right m-0">{{ data.valorConsumido | currency }}</p>
                    </template>
                </app-tabela>
            </div>
        </b-modal>
    </div>
</template>

<script>
import ContratosServicos from './../ContratosServicos'

export default {
    props: {
        fase: {
            type: Object,
            default: () => ({})
        },
    },

    data() {
        return {
            consumos: null,
            totalConsumo: null, 
            mostrarModal: false,
            campos: [
                {
                    key: 'descricaoItem',
                    label: 'Descrição do Item',
                    filterable: true,
                    sortable: true
                },    
                {
                    key: 'valorConsumido',
                    label: 'Valor Consumido',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
            ],
            itensPorPagina: 100
        }
    },

    methods: {
        limparVariaveis() {
            this.consumoPorItem = null
        },

        ObterConsumoPorItem() {
            this.$store.dispatch('addRequest')
            ContratosServicos.ObterConsumoFasePorItem(this.fase.faseContratoId).then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.consumos = response.data.consumos
                            this.totalConsumo = response.data.totalConsumo
                            this.mostrarModal = true
                        } else {
                            this.$toast.error(
                                'Falha ao obter consumo da fase por itens',
                                'OK',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        }
    },
    
    computed: {
        mostrarBotao() {
            if (this.$moment().format() < this.fase.dataInicioVigencia) {
                return false
            }

            return true
        }
    }
}

</script>